import { combineReducers } from 'redux'
import { userReducer } from './userReducer';
import { commandReducer } from './commandReducer';

export const rootReducer = combineReducers({
    user:userReducer,
    command:commandReducer
})